module.exports = __webpack_public_path__ + "static/media/dpz-logo.6deaa02a.svg";